import { createFileRoute } from "@tanstack/react-router";
import { filterQuizRoute } from "@/app-clients/matching-flow/filter-quiz-route-data";
import { FilterQuizPage } from "@/app-clients/matching-flow/filter-quiz-route";

export const Route = createFileRoute("/filter-quiz")({
    validateSearch: filterQuizRoute.validateSearch,
    head: filterQuizRoute.head,
    component: FilterQuizPage,
});
